import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components/macro";

import { createSearchParams, Navigate, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../store";
import userSlice from "../../../reducer/user";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducer/index";
import axios from "axios";
import { settingUser } from "../../../reduxaction/user";
import Modal from "../../../components/Modal";

const Container = styled.div``;

export const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 0;
  font-size: 1.13em;
  position: relative;
  .pagetit {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 2.5vw;
    font-family: "spoqa500";
  }
  .move-btn {
    position: absolute;
    height: 100%;
    top: 0;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
      cursor: pointer;
      width: 100%;
    }
  }

  @media screen and (min-width: 1050px) {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #dddddd;
    background-color: #fff;
    padding: 20px 0;
    font-size: 1.4em;
    position: relative;

    .move-btn {
      position: absolute;
      width: 1.5%;
      height: 100%;
      top: 0;
      right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      & img {
        cursor: pointer;
        width: 100%;
      }
    }
  }
`;

const FirstCon = styled.div`
  height: 86px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
`;

const FlexCon = styled.div`
  display: flex;
  padding: 0 30px;
  justify-content: space-between;
  div {
    margin: 0 10px;
    display: flex;
    font-size: 16px;
    align-items: center;
  }

  .profilecon {
    background-color: #73972c;
    border: 0.5px solid #73972c;
    width: 80px;
    height: 35px;
    color: white;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;

const CrossLine = styled.div`
  display: flex;
  padding: 5px 0px;
  border: 1px solid lightgray;
  background-color: #f5f5f5;
  margin-top: 15px;
`;

const Setting = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { me, Routerpath, settingUserInfo } = useSelector(
    (state: RootState) => state.user
  );

  const [logoutmodal, setLogoutmodal] = useState<boolean>(false);
  const [deletemodal, setDeletemodal] = useState<boolean>(false);

  useEffect(() => {
    dispatch(userSlice.actions.Routerpath("/Setting"));
  }, []);

  const gotonavifunc = useCallback(
    (type: string) => {
      if (type === "AddressList") {
        navigate("/AddressList");
      } else if (type === "ProfileAdjust") {
        if (
          (settingUserInfo?.userId && settingUserInfo?.name,
            settingUserInfo?.memberId)
        ) {
          navigate({
            pathname: "/ProfileAdjust",
            search: createSearchParams({
              userId: settingUserInfo?.userId,
              name: settingUserInfo?.name,
              memberId: settingUserInfo?.memberId.toString(),
            }).toString(),
          });
        }
      } else if (type === "NotiSetting") {
        navigate("/NotiSetting");
      }
    },
    [settingUserInfo]
  );

  useEffect(() => {
    let accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
    } else {
      navigate("/SignIn");
    }
  }, []);

  useEffect(() => {
    dispatch(settingUser(null));
  }, []);

  const modalfunc = useCallback(
    (type: string, memberId?: number, userId?: string) => {
      if (type === "deletemodal") {
        setDeletemodal(true);
      } else if (type === "logout") {
        setLogoutmodal(true);
      }
    },
    []
  );

  const deletepostfunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        let datas: any = {
          memberId: settingUserInfo?.memberId,
          userId: settingUserInfo?.userId,
        };

        const response = await axios.delete(`/ifactory/api/member/delete`, {
          data: datas,
        });
        localStorage.clear();
        dispatch(userSlice.actions.reMoveme());
        setDeletemodal(false);
        navigate("/SignIn");
      } else if (type === "NO") {
        setDeletemodal(false);
      }
    },
    [deletemodal, settingUserInfo]
  );

  const logoutpostfunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        localStorage.clear();
        dispatch(userSlice.actions.reMoveme());
        setLogoutmodal(false);
        navigate("/SignIn");
      } else if (type === "NO") {
        setLogoutmodal(false);
      }
    },
    [logoutmodal]
  );

  return (
    <Container>
      <PageTop>
        <p className="pagetit">개인설정</p>
        <p className="move-btn">
          <img
            src="./img/X.svg"
            onClick={() => {
              navigate(-1);
            }}
            alt="X"
          />
        </p>
      </PageTop>
      <FirstCon>
        <FlexCon>
          <div>
            <div className="main-icon">
              <img src="/img/profile.svg" />
            </div>
            <div>{settingUserInfo?.userId}</div>
            <div style={{ color: "#656565" }}>{settingUserInfo?.name}</div>
          </div>
          <div
            className="profilecon"
            onClick={() => gotonavifunc("ProfileAdjust")}
          >
            프로필 수정
          </div>
        </FlexCon>
      </FirstCon>
      <CrossLine></CrossLine>
      {(settingUserInfo?.roleCode === 'ADMIN' ?
        (
          <>

            {/* 수정 시작 */}
            <FirstCon
              style={{ borderBottom: "1px solid lightgray" }}
              onClick={() => gotonavifunc("AddressList")}
            >
              <FlexCon>
                <div>
                  <div>계정목록</div>
                </div>
                <div style={{ fontSize: 18, color: "gray", cursor: "pointer" }}>
                  {">"}
                </div>
              </FlexCon>
            </FirstCon>
            {/* 수정 끝 */}


            <FirstCon onClick={() => gotonavifunc("NotiSetting")}>
              <FlexCon>
                <div>
                  <div>알림설정</div>
                </div>
                <div style={{ fontSize: 18, color: "gray" }}>{">"}</div>
              </FlexCon>
            </FirstCon>
            <CrossLine></CrossLine>
          </>
        ) :
        (
          <>

            <FirstCon onClick={() => gotonavifunc("NotiSetting")}>
              <FlexCon>
                <div>
                  <div>알림설정</div>
                </div>
                <div style={{ fontSize: 18, color: "gray" }}>{">"}</div>
              </FlexCon>
            </FirstCon>
            <CrossLine></CrossLine>
          </>
        )
      )
        // (
        //   <>

        //     {/* 수정 시작 */}
        //     <FirstCon
        //       style={{ borderBottom: "1px solid lightgray" }}
        //       onClick={() => gotonavifunc("AddressList")}
        //     >
        //       <FlexCon>
        //         <div>
        //           <div>계정목록</div>
        //         </div>
        //         <div style={{ fontSize: 18, color: "gray", cursor: "pointer" }}>
        //           {">"}
        //         </div>
        //       </FlexCon>
        //     </FirstCon>
        //     {/* 수정 끝 */}


        //     <FirstCon onClick={() => gotonavifunc("NotiSetting")}>
        //       <FlexCon>
        //         <div>
        //           <div>알림설정</div>
        //         </div>
        //         <div style={{ fontSize: 18, color: "gray" }}>{">"}</div>
        //       </FlexCon>
        //     </FirstCon>
        //     <CrossLine></CrossLine>
        //   </>
        // )
      }


      <FirstCon
        style={{ borderBottom: "1px solid lightgray" }}
        // onClick={logout}
        onClick={() => modalfunc("logout")}
      >
        <FlexCon>
          <div>
            <div>로그아웃</div>
          </div>
          <div
            // onClick={logout}
            style={{ fontSize: 18, color: "gray", cursor: "pointer" }}
          >
            {">"}
          </div>
        </FlexCon>
      </FirstCon>
      <FirstCon>
        <FlexCon onClick={() => modalfunc("deletemodal")}>
          <div>
            <div>계정 탈퇴하기</div>
          </div>
          <div style={{ fontSize: 18, color: "gray" }}>{">"}</div>
        </FlexCon>
      </FirstCon>

      {logoutmodal && (
        <Modal
          title={"정말로 로그아웃 하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => logoutpostfunc("YES")}
          secondclick={() => logoutpostfunc("NO")}
        />
      )}

      {deletemodal && (
        <Modal
          title={"정말로 탈퇴하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => deletepostfunc("YES")}
          secondclick={() => deletepostfunc("NO")}
        />
      )}
    </Container>
  );
};

export default Setting;
